import { useChat as y } from "./contact-channels5.js";
import { NRLogger as m } from "./contact-channels45.js";
import { useMutation as P } from "./contact-channels92.js";
import { useRef as p, useEffect as S } from "react";
import { attempt as g } from "./contact-channels54.js";
const F = 1e4, U = 200, v = "initCAfromExternalSource", k = 3e3, L = (l, h) => {
  document.dispatchEvent(new CustomEvent(l, { detail: h }));
}, V = () => {
  const { data: l, isLoading: h } = y(), s = p(l), r = p(h), f = p(null);
  S(() => {
    s.current = l, r.current = h;
  }, [l, h]), S(() => () => {
    var t;
    (t = f.current) == null || t.abort(), f.current = null;
  }, []);
  const A = (t) => {
    var n, u;
    if (typeof window < "u") {
      const o = window;
      o.$Lightning || (o.isChatNowClicked = !0);
    }
    t ? L(t.eventName, t.payload) : L(v, {
      eventName: v,
      timestamp: Date.now(),
      button: "help-center-chat-now"
    }), m.info("Contact Channels: Chat Actions", {
      chatStatus: ((u = (n = s.current) == null ? void 0 : n.plainData) == null ? void 0 : u.chatStatus) || "unset",
      customEvent: t == null ? void 0 : t.eventName,
      action: "StartChat",
      isLoading: r.current
    });
  }, N = (t) => {
    const n = new AbortController();
    return f.current = n, new Promise((u, o) => {
      const C = (t == null ? void 0 : t.timeoutDuration) || F;
      let i = null, w = !1;
      const D = () => {
        var a, c, e;
        d(), m.error("Contact Channels: Chat Actions", {
          chatStatus: ((c = (a = s.current) == null ? void 0 : a.plainData) == null ? void 0 : c.chatStatus) || "unset",
          customEvent: (e = t == null ? void 0 : t.customEvent) == null ? void 0 : e.eventName,
          action: "StartChat",
          isLoading: r.current,
          type: "ABORTED",
          message: "Component unmounted while waiting for chat"
        }), o(new Error("Component unmounted while waiting for chat"));
      }, I = () => {
        var a, c, e;
        d(), n.signal.aborted || (m.error("Contact Channels: Chat Actions", {
          chatStatus: ((c = (a = s.current) == null ? void 0 : a.plainData) == null ? void 0 : c.chatStatus) || "unset",
          customEvent: (e = t == null ? void 0 : t.customEvent) == null ? void 0 : e.eventName,
          action: "StartChat",
          isLoading: r.current,
          type: "TIMEOUT",
          message: "Timeout waiting for chat to be online"
        }), o(new Error("Timeout waiting for chat to be online")));
      }, b = () => {
        var T, E;
        if (n.signal.aborted) return;
        const a = s.current, c = r.current, e = (T = a == null ? void 0 : a.plainData) == null ? void 0 : T.chatStatus;
        if (e === "preparing" && i === null && (i = Date.now()), e === "preparing" && i !== null && !w && Date.now() - i > k) {
          w = !0, m.warn("Contact Channels: Chat Actions", {
            chatStatus: e,
            action: "StartChat",
            type: "PREPARING_STATE_FALLBACK",
            message: "Auto-triggering CAonChatInit due to stuck preparing state",
            customEvent: (E = t == null ? void 0 : t.customEvent) == null ? void 0 : E.eventName
          }), document.dispatchEvent(new CustomEvent("CAonChatInit"));
          return;
        }
        if (!c && e === "online") {
          d();
          try {
            A(t == null ? void 0 : t.customEvent), u({ success: !0 });
          } catch (O) {
            o(O);
          }
        }
      }, d = () => {
        clearInterval(R), clearTimeout(_);
      };
      n.signal.addEventListener("abort", D);
      const R = setInterval(b, U), _ = setTimeout(I, C);
    });
  };
  return P({
    mutationKey: ["chatActions"],
    mutationFn: async (t) => {
      var C, i;
      const n = (i = (C = s.current) == null ? void 0 : C.plainData) == null ? void 0 : i.chatStatus;
      if (n === "online")
        return A(t == null ? void 0 : t.customEvent), { success: !0 };
      if (!r.current && n === "offline")
        return m.info("Contact Channels: Chat Actions", {
          message: "Chat Action triggered when Chat is Offline",
          isLoading: r.current,
          action: "StartChat",
          chatStatus: n
        }), { success: !1 };
      const { data: u, error: o } = await g(N(t));
      return o ? { success: !1, error: o.message } : { success: u.success };
    }
  });
};
export {
  V as useStartChat
};
//# sourceMappingURL=contact-channels59.js.map
